import {
  ShieldCheck, FlaskConical, ShieldAlert, Ban, AlertTriangle,
} from "lucide-react";

const STATUS_CONFIG = {
  action_ready: {
    icon: ShieldCheck,
    label: "Action Ready",
    color: "text-[hsl(var(--success))]",
    bg: "bg-[hsl(var(--success))]/10 border-[hsl(var(--success))]/30",
    description: "Analysis meets decision-grade standards. Full Improve workflow enabled.",
  },
  pilot_required: {
    icon: FlaskConical,
    label: "Pilot Required",
    color: "text-[hsl(var(--warning))]",
    bg: "bg-[hsl(var(--warning))]/10 border-[hsl(var(--warning))]/30",
    description: "Analysis is moderate. Pilot plan and results must be completed before gate advancement.",
  },
  exploratory_only: {
    icon: ShieldAlert,
    label: "Exploratory Only",
    color: "text-orange-400",
    bg: "bg-orange-400/10 border-orange-400/30",
    description: "Exploratory only — do not deploy. Pilot and experiment plan are required.",
  },
  blocked: {
    icon: Ban,
    label: "Blocked",
    color: "text-destructive",
    bg: "bg-destructive/10 border-destructive/30",
    description: "Analysis does not meet minimum evidence standards. Return to Measure/Analyze.",
  },
  unknown: {
    icon: ShieldAlert,
    label: "Not Evaluated",
    color: "text-muted-foreground",
    bg: "bg-muted border-border",
    description: "No Staged Root Cause Analysis has been run yet. Run analysis in the Analyze phase.",
  },
};

export default function ReadinessBanner({ status, score, readiness }) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.unknown;
  const Icon = cfg.icon;

  return (
    <div className={`border rounded-lg p-4 ${cfg.bg}`} data-testid="readiness-banner">
      <div className="flex items-center gap-3">
        <Icon className={`w-6 h-6 ${cfg.color} shrink-0`} />
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-3">
            <span className={`font-heading font-semibold ${cfg.color}`} data-testid="readiness-status">{cfg.label}</span>
            <span className="text-xs font-mono text-muted-foreground" data-testid="readiness-score">Score: {score}/100</span>
          </div>
          <p className="text-sm text-muted-foreground mt-0.5">{cfg.description}</p>
        </div>
      </div>
      {readiness?.reasons?.length > 0 && status !== "action_ready" && status !== "unknown" && (
        <div className="mt-3 pl-9 space-y-1">
          {readiness.reasons.map((r, i) => (
            <p key={i} className="text-xs text-muted-foreground flex items-start gap-1.5">
              <span className="text-muted-foreground/50 mt-0.5">-</span> {r}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}
